import { useEffect } from "react";
import { LOCALES, DEFAULT_LOCALE, PROD_BASE, lpPath, localeTag, t as translate, OYG_SEO_LOCALES } from "@/i18n";

// Localized SEO: unique title + description per locale, canonical to the
// production URL, full hreflang set with x-default → English.
// Production launch approved: public landing pages are indexable (index, follow).
export const useSeo = ({ locale, titleKey, descKey, titleFallback, descFallback }) => {
  useEffect(() => {
    document.title = translate(locale, titleKey, titleFallback);

    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("name", "description", translate(locale, descKey, descFallback));
    setMeta("name", "robots", "index, follow");

    document.head.querySelectorAll('link[data-seo="canonical"], link[data-seo="hreflang"]').forEach((e) => e.remove());
    const addLink = (rel, hreflang, href) => {
      const el = document.createElement("link");
      el.rel = rel;
      el.href = href;
      el.dataset.seo = hreflang ? "hreflang" : "canonical";
      if (hreflang) el.hreflang = hreflang;
      document.head.appendChild(el);
    };
    addLink("canonical", null, `${PROD_BASE}${lpPath(locale)}`);
    OYG_SEO_LOCALES.forEach((l) => addLink("alternate", localeTag(l), `${PROD_BASE}${lpPath(l)}`));
    addLink("alternate", "x-default", `${PROD_BASE}${lpPath(DEFAULT_LOCALE)}`);
  }, [locale, titleKey, descKey, titleFallback, descFallback]);
};
